module.exports = __webpack_public_path__ + "static/media/right-img@2x.ec3f4858.png";